import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { LazyLoadEvent } from 'primeng/api';
import { CityService } from 'src/app/manage/city/service/city.service';
import { CountryService } from 'src/app/manage/country/service/country.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { AcademybranchesService } from 'src/app/services/academybranches.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../../services/common.service';
import { ComingSoonComponent } from 'src/app/components/pages/coming-soon/coming-soon.component';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
@Component({
  selector: 'app-our-tournament',
  templateUrl: './our-tournaments.component.html',
  styleUrls: ['./our-tournaments.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class OurTournamentsComponent implements OnInit {
  public showingForm: boolean = false;
  branchform: FormGroup
  public loggedInAcademyUserId;
  submitted = false;
  public countrylist: any[] = [];
  errorMessage = '';
  public stateList: any[] = [];
  public cityList: any[] = [];
  citylist: any = [];
  statelist: any = [];
  statecode;
  statename;
  cityname;
  citycode;
  countryname;
  countrycode;
  tournamentList: any;
  imagedataa: any;
  catdata: any;
  mcatdata: any;
  private lazyLoadEvent: LazyLoadEvent;
  public totalRecords = 0;

  public loading: boolean;

  id: string;
  pagetitle: string;
  isAddMode: boolean = true;
  branchImage: any;
  imageSize = environment.imageSize;
  uploadedFiles: any[] = [];
  loggedInAcademy;
  loggedInAcademyId;
  item: any;
  branchid: any;
  Imagebranch: any;
  showUploadedpic: boolean = false;
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',

    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  public disabled: boolean = false;
  public courtTypeList = environment.courtTypeList;
  branchlist: any;
  branchimage: any;
  constructor(private formBuilder: FormBuilder,
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private branchservice: AcademybranchesService,
    private commonService: CommonService,
    private confirmationService: ConfirmationService,
    private tournamentsService: TournamentsService
  ) { }

  ngOnInit(): void {
    this.getCountry();
    this.id = this.route.snapshot.paramMap.get("id");
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyUserId = this.loggedInAcademy.userdata['id'];
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'expire') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }
    this.branchform = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-_]+( [a-zA-Z',.-_]+)*){2,30}")]],
      mobileNumber: ['', [Validators.required, Validators.pattern("[0-9 ]{10}"), Validators.minLength(10)]],
      email: ['', [Validators.required, Validators.email, CustomValidators.email]],
      webUrl: ['', [Validators.required, Validators.pattern("^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.|w|ww|www))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$"
      )]],
      address: ['', [Validators.required]],
      countryname: ['', [Validators.required]],
      statename: ['', [Validators.required]],
      cityname: ['', [Validators.required]],
      zipcode: ['', Validators.required]
    }, { updateOn: "blur" });
    this.loadbranch();
    this.loadTournament(this.lazyLoadEvent);
    //this.getTournamentsLocation();
  }

  loadTournament(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 8;
    let query = "filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId + "&filterByCreatedBy=" + this.loggedInAcademyUserId;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 8;
      }
    }

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    //console.log("data", query)
    this.tournamentsService.getTournamentsListWithAuth(query).subscribe(
      data => {
        window.scroll(0, 0);
        // console.log("xxx",data);
        this.loading = false;
        this.tournamentList = data.data.items;
        this.totalRecords = data.data.totalCount;
        //console.log(tournamentList);
        this.tournamentList.forEach((element) => {
          let tmpcat = [];
          let t = element.tournamentCategories;
          t.forEach(catelement => {
            tmpcat.push(catelement.matchtypeData);
          })
          let uniqueData = [];
          let uniqueIds = {};
          tmpcat.forEach(item => {            
            if (!uniqueIds[item[0]['name']]) {
              uniqueIds[item[0]['name']] = true;
              uniqueData.push(item[0]['name']);
            }
          });
          //element.matchDataName=Object.keys(uniqueIds);
          element.matchDataName=uniqueData.join(', ');
          element.matchDataArray=uniqueData;
          if(element.matchDataArray.length > 3){
            element.showComma = true;
          } else {
            element.showComma = false;
          }
          this.imagedataa = element['academyPic'];
          let tmp = this.courtTypeList.find(o => o.value === element.courttype);
          if (tmp != undefined) {
            element.court = tmp.label;
          } else {
            element.court = '';
          }
        })
      },
      err => {
        this.errorMessage = err.error.message;
      }
    )
  }

  onclickdetails(id) {
    this.router.navigate(['tournaments/factsheet/' + id]);
  }


  onClickEditTournament(id) {
    this.router.navigate(['createtournament/' + id + '/0']);
  }

  onClicktournamentPlayerList(id) {
    console.log(id)
    this.router.navigate([`player-list/${id}`]);
  }
  onClickEditdraw(id) {
 
    this.router.navigate([`tournament-draw/${id}`]);
  }
  get f() {
    return this.branchform.controls;
  }
  openmodal() {
    this.pagetitle = 'Add Branch';
    this.Imagebranch = '';
    this.uploadedFiles = [];
    this.isAddMode = true;
    this.showingForm = true;
    this.showUploadedpic = false;
    this.citylist = [];
    this.citycode = "";
    this.cityname = "";
    this.statecode = '';
    this.statename = '';
    this.statelist = [];
    this.getCountry();
    this.branchform.reset();
  }
  onHighlightModalClose() {
    this.showingForm = false;
  }
  onClickEdit(id) {
    this.pagetitle = 'Edit Branch';
    this.isAddMode = false;
    this.showingForm = true;
    this.getbranchdetails(id);
  }
  getbranchdetails(id) {
    this.branchservice.getAcademyBranchesdetails(id).subscribe(async res => {
      this.item = res;
      this.branchid = id;

      this.branchform.controls.name.setValue(this.item.name);
      this.branchform.controls.mobileNumber.setValue(this.item.mobileNumber);
      this.branchform.controls.email.setValue(this.item.email);
      this.branchform.controls.webUrl.setValue(this.item.webUrl);
      this.branchform.controls.address.setValue(this.item.address);
      this.getStates("false", this.item['countrycode']);

      this.branchform.get('countryname').setValue({ name: this.item['countryname'], code: this.item['countrycode'] });
      if (this.item['statecode']) {
        this.cityname = this.item['cityname'];
        await this.getCities("false", this.item['statecode']);
        this.branchform.get('statename').setValue({ name: this.item['statename'], code: this.item['statecode'] });
      }
      if (this.item['cityname']) {
        this.cityname = this.item['cityname'];
        this.branchform.get('cityname').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
      }

      // this.branchform.get('countryname').setValue({ name: this.item['countryname'], code: this.item['countrycode'] });
      // this.branchform.get('statename').setValue({ name: this.item['statename'], code: this.item['statecode'] });
      // this.branchform.get('cityname').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
      this.branchform.controls.zipcode.setValue(this.item.zipcode);

      if (this.item['image'] != undefined) {
        this.Imagebranch = this.item['image'];
        this.showUploadedpic = true;
      } else {
        this.showUploadedpic = false;
      }
    })
  }

  loadbranch() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.branchservice.getAcademyBranches(query).subscribe(
      data => {
        this.loading = false;
        this.branchlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  getCountry() {
    this.statelist = [];
    this.commonService.getCountryList().subscribe(
      data => {
        this.countrylist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getStates(fromForm, event) {
    this.citylist = [];
    this.statecode = "";
    this.statename = "";
    this.citycode = "";

    if (fromForm == "true") {
      this.branchform.get('zipcode').reset();
      this.countrycode = event.value.code;
      this.countryname = event.value.name;
    } else {
      this.countrycode = event;
    }

    this.commonService.getStateList(this.countrycode).subscribe(
      data => {
        this.statelist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }


  async getCities(fromForm, event) {
    this.citylist = [];
    this.citycode = "";
    this.cityname = "";
    if (fromForm == "true") {
      this.branchform.get('zipcode').reset();
      this.statecode = event.value.code;
      this.statename = event.value.name;
    } else {
      this.statecode = event;
    }


    this.commonService.getCityList(this.statecode).subscribe(
      data => {

        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let cityObj = {
              name: element['name'],
              code: element['code']
            }
            this.citylist.push(cityObj);
          });

          this.citylist.forEach(cElement => {
            if (this.cityname == cElement.name) {
              this.branchform.get('cityname').setValue({ name: cElement['name'], code: cElement['code'] });
            }
          });
        }

      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onCitySelect(event) {
    this.cityname = event.value.name;
    this.citycode = event.value.code;
  }

  picUploader(event) {
    // console.log("uploadimage",event.file);
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.branchImage = reader.result;
        }
      }
    }
  }

  onsubmit() {
    this.submitted = true;
    if (this.branchform.invalid) {
      return;
    }
    var branchData = this.branchform.value;
    branchData['branchImage'] = this.branchImage;
    branchData['countrycode'] = this.countrycode;
    branchData['countryname'] = this.countryname;
    branchData['statecode'] = this.statecode;
    branchData['statename'] = this.statename;
    branchData['citycode'] = this.citycode;
    branchData['cityname'] = this.cityname;
    branchData['academyId'] = this.loggedInAcademyId;
    branchData['status'] = true;
    branchData['disable'] = false;
    if (this.isAddMode) {
      branchData = JSON.stringify(branchData, null, 4);
      this.addBranch(branchData);
    } else {
      this.isAddMode = false
      branchData = JSON.stringify(branchData, null, 4);
      this.updateBranch(branchData);
    }
  }
  addBranch(branchData) {
    this.branchservice.addAcademyBranches(branchData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Branch Added', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['/academies-profile/branches']);
        }, 2000);
        this.Imagebranch = '';
        this.uploadedFiles = [];
        this.branchform.reset();
        this.onHighlightModalClose();
        //this.loadbranch();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Branch failed', life: 6000 });
        this.onHighlightModalClose();
        this.branchform.reset();
      })
    );
  }
  updateBranch(branchData) {
    this.branchservice.updateAcademyBranches(this.branchid, branchData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Branch Updated', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['/academies-profile/branches']);
        }, 2000);
        this.uploadedFiles = [];
        this.Imagebranch = '';
        this.submitted = false;
        this.showingForm = false;
        this.onHighlightModalClose();
        this.branchform.reset();
        this.loadbranch();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Branch failed', life: 6000 });
        this.onHighlightModalClose();
        this.branchform.reset();
      })
    );
  }

  onClickDelete(this) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this Tournament?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let disableStatus;
        if (this.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        let updatedata = '{"disable":' + disableStatus + '}';
        this.branchservice.updateAcademyBranches(this.id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Branch Deleted', life: 3000 });
            this.loadbranch();
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }
  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }
}

